import { gql } from '@apollo/client'

export const BUSINESS_BOTTLENECK_QUERY = gql`
  query CoachBusinessBottleneck {
    currentUser {
      attributes {
        ... on Coach {
          bookingUrl
          coachProfile {
            slug
          }
          preferences {
            leadAutoReplyEnabled
          }
          businessBottleneck {
            constraintKey
            title
            body
            you {
              retention90d
              arpsDollars
              packAttachRate
            }
            peers {
              medianArpsDollars
              medianRetention90d
              medianPackAttach
              cohortSize
            }
            plays {
              title
              body
              action
              path
              mutationName
              outreachTargets {
                id
              }
            }
          }
        }
      }
    }
  }
`

export const CLEAR_EXTERNAL_BOOKING_URL = gql`
  mutation ClearCoachExternalBookingUrl {
    updateCoachExternalBookingUrl(externalBookingUrl: null) {
      success
      message
      coach {
        bookingUrl
        id
      }
    }
  }
`
